<template>
  <v-container fluid >
    <v-row wrap align-center>
      <v-col cols=12>
        <div class="text-center">
          <h1 class="headline font-weight-medium">
            {{ $vuetify.lang.t(`$vuetify.landing.press.title`) }}
          </h1>
        </div>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>
    <v-row wrap justify="space-around" align-content="center" align="center">
      <v-col cols="12" md="3" v-for="item in press" :key="item.path" align-self="center" justify-self="center"
             class="my-5">
        <a :href="typeof(item.link) === 'string' ? item.link : item.link[$vuetify.lang.current]" target="_blank">
          <v-img class="logo mx-auto" :src="item.path" :max-width="item.width" :class="item.class" eager></v-img>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import metaMixin from '../../mixins/metaMixin'

export default {
  name: 'pressSlide',
  mixins: [metaMixin],
  data: () => ({
    press: [
      {
        link: 'https://russia.tv/video/show/brand_id/3838/episode_id/2210742/video_id/2231386/',
        path: require('@/assets/landing/press/logo_russia_1.png'),
        width: 250
      },
      {
        link: 'https://www.kommersant.ru/doc/4102477',
        path: require('@/assets/landing/press/logo_kommersant.png'),
        width: 250
      },
      {
        link: 'https://rg.ru/2019/10/01/reg-szfo/smartfon-smozhet-predotvratit-avarii-na-doroge.html',
        path: require('@/assets/landing/press/logo_rg.png'),
        width: 200
      },
      {
        link: {
          'ru': 'http://www.rscf.ru/ru/node/pomogaet-voditelyu',
          'en': 'http://www.rscf.ru/en/node/scientists-designed-driver-monitoring-application-for-smartphone'
        },
        path: require('@/assets/landing/press/logo_rnf.png'),
        width: 250
      },
      {
        link: 'https://www.5-tv.ru/news/264924/vrossii-poavilos-protivoavarijnoe-prilozenie-dla-smartfonov-video/',
        path: require('@/assets/landing/press/logo_5_tv.svg'),
        width: 150
      },
      {
        link: 'https://www.gazeta.ru/science/news/2019/09/17/n_13475227.shtml',
        path: require('@/assets/landing/press/logo_gazeta_ru.png'),
        width: 200
      },
      {
        link: 'https://nauka.tass.ru/nauka/6894562',
        path: require('@/assets/landing/press/logo_tass.jpg'),
        width: 200
      },
      {
        link: 'https://indicator.ru/mathematics/prilozhenie-ne-pozvolit-nevnimatelnym-18-09-2019.htm',
        path: require('@/assets/landing/press/logo_indicator.svg'),
        width: 240
      },
      {
        link: 'https://auto.rambler.ru/roadaccidents/42843368-prilozhenie-dlya-smartfona-ne-pozvolit-voditelyu-byt-nevnimatelnym/',
        path: require('@/assets/landing/press/logo_rambler_ru.svg'),
        width: 200
      },
      {
        link: 'https://news.ru/science/rossijskie-matematiki-sozdali-prilozhenie-sohranyayushee-vnimanie-voditelej/',
        path: require('@/assets/landing/press/logo_news_ru.svg'),
        width: 315,
        class: 'news_ru'
      },
      {
        link: {
          'ru': 'https://news.itmo.ru/ru/startups_and_business/startup/news/8846/',
          'en': 'https://news.itmo.ru/en/startups_and_business/startup/news/8846/'
        },
        path: require('@/assets/landing/press/logo_ifmo_news.png'),
        width: 200
      },
      {
        link: 'http://rostransport.com/news/201486/',
        path: require('@/assets/landing/press/logo_transport_rf.png'),
        width: 300
      },
      {
        link: 'https://www.poisknews.ru/news/rossijskoe-prilozhenie-pomozhet-voditelyam-s-bezopasnostyu-na-doroge/',
        path: require('@/assets/landing/press/logo_poisk.png'),
        width: 200
      },
      {
        link: 'https://vm.ru/news/751040-rossijskie-uchenye-sozdali-prilozhenie-dlya-povysheniya-vnimatelnosti-voditelej',
        path: require('@/assets/landing/press/logo_vm.png'),
        width: 200
      },
      {
        link: 'http://fsnovosti.ru/transport/sozdano-prilozhenie-dlya-smartfona-kotoroe-pomozhet-voditelyu-ostavatsya-vnimatelnym/',
        path: require('@/assets/landing/press/logo_fsn.png'),
        width: 200
      },
      {
        link: 'http://4pda.ru/2019/09/29/362157/',
        path: require('@/assets/landing/press/logo_4pda.png'),
        width: 200
      },
      {
        link: 'http://www.rscf.ru/ru/node/dveri-svoikh-laboratoriy',
        path: require('@/assets/landing/press/logo_nauka_0.png'),
        width: 200
      }
    ]
  }),

  metaInfo: {
    title: 'Drive Safely | Press',
    meta: [
      { name: 'description', content: 'News about the Drive Safely project' },
      { property: 'og:title', content: 'Drive Safely press' },
      { property: 'og:site_name', content: 'Drive Safely' },
      { property: 'og:description', content: 'News about the Drive Safely project' },
      { property: 'og:url', content: 'https://mobiledrivesafely.com/press' }
    ]
  }
}
</script>

<style scoped>
  .logo {
    transition-duration: .5s;
    -webkit-transition-duration: .5s;
    -moz-transition-duration: .5s;
    -o-transition-duration: .5s;
    opacity: 0.9;
  }

  .logo:hover {
    transform: scale(1.2, 1.2);
    transition-duration: .5s;
    -webkit-transition-duration: .5s;
    -moz-transition-duration: .5s;
    -o-transition-duration: .5s;
    opacity: 1;
  }

  .news_ru {
    min-height: 50px;
  }
</style>
